import React, { createContext } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { SOCKET_CONNECT, SOCKET_DISCONNECT } from '../actions/socketTypes'
import { LOGOUT } from '../actions/authTypes'
export const userContext = createContext()

const PrivateRoute = ({children}) => {
    const isLoggedIn = useSelector((state)=>state.authState.isLoggedIn)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (isLoggedIn) {
            dispatch({type: SOCKET_CONNECT})
        }
        const handleStorageEvent = (e) => {
            if (e.key === 'logout-event') {
                dispatch({type: LOGOUT})
                navigate('/login')
            }
        }
        window.addEventListener('storage', handleStorageEvent)
        return () => {
            dispatch({type: SOCKET_DISCONNECT})
            window.removeEventListener('storage', handleStorageEvent)
        }
    }, [isLoggedIn,dispatch,navigate])


    return (
        isLoggedIn ? children : <Navigate to = "/login" replace = {true}/>
    )
}

export default PrivateRoute